import React, { useState } from "react";
import {
  Button,
  Stack,
  CircularProgress,
  Alert,
  Snackbar
} from "@mui/material";
import { getAdditionalBundleCouponPurchase } from "../../api/userApi";

export default function PurchaseButtons() {
  const [loading, setLoading] = React.useState(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const handleCheckout = async (priceId) => {
    try {
      setLoading(priceId);
      // POST to your backend API that creates a Checkout Session
      const res = await getAdditionalBundleCouponPurchase(priceId);
      const url = await res?.stripeCheckoutLink;
      await navigator.clipboard.writeText(url);
      setSnackbarMessage("Stripe checkout URL copied to clipboard!");
      setOpenSnackbar(true);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(null);
    }
  };

  return (
    <>
      {" "}
      <Snackbar
        open={openSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        autoHideDuration={1000}
        onClose={() => setOpenSnackbar(false)}
      >
        <Alert
          onClose={() => setOpenSnackbar(false)}
          severity="success"
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
      <Stack
        spacing={2}
        direction="column"
        alignItems="center"
        gap={5}
        sx={{
          mt: 4,
          display: "flex",
          flexDirection: "row",
          justifyContent: "center"
        }}
      >
        <Button
          variant="contained"
          size="large"
          disabled={loading === "PRICE_1997_UPGRADE"}
          onClick={() => handleCheckout("PRICE_1997_UPGRADE")}
        >
          {loading === "PRICE_1997_UPGRADE" ? (
            <CircularProgress size={24} />
          ) : (
            "Unlock Lifetime Access – $1,997"
          )}
        </Button>

        <Button
          variant="outlined"
          size="large"
          sx={{ mt: "0 !important" }}
          disabled={loading === "PRICE_397_BUNDLE"}
          onClick={() => handleCheckout("PRICE_397_BUNDLE")}
        >
          {loading === "PRICE_397_BUNDLE" ? (
            <CircularProgress size={24} />
          ) : (
            "Get the 3‑Program Bundle – $397"
          )}
        </Button>
        <Button
          variant="outlined"
          size="large"
          sx={{ mt: "0 !important" }}
          disabled={loading === "SUB_39_MONTH"}
          onClick={() => handleCheckout("SUB_39_MONTH")}
        >
          {loading === "SUB_39_MONTH" ? (
            <CircularProgress size={24} />
          ) : (
            "New Monthly Plan – $39"
          )}
        </Button>
        <Button
          variant="outlined"
          size="large"
          sx={{ mt: "0 !important" }}
          disabled={loading === "SUB_397_YEAR"}
          onClick={() => handleCheckout("SUB_397_YEAR")}
        >
          {loading === "SUB_397_YEAR" ? (
            <CircularProgress size={24} />
          ) : (
            "New Yearly Plan – $397"
          )}
        </Button>
      </Stack>
    </>
  );
}
